import Vue from 'vue'
import Router from 'vue-router'
import jobIndex from '@/pages/job/index' // 幼师端首页
import jobPost from '@/pages/job/post' // 幼师端职位
import jobResume from '@/pages/job/resume' // 幼师端简历
import jobAccountNumber from '@/pages/job/accountNumber' // 幼师端简历
import jobPostDetail from '@/pages/job/postDetail' // 幼师端职位详情
import jobSchoolDetail from '@/pages/job/schoolDetail' // 幼师端园所详情

import bossIndex from '@/pages/boss/post' // 园长端职位列表
import bossPostDetail from '@/pages/boss/postDetail' // 园长端职位详情、添加
import bossSchool from '@/pages/boss/school' // 园长端我的园所
import bossResume from '@/pages/boss/resume' // 园长端简历列表
import bossResumeDetail from '@/pages/boss/resumeDetail' // 园长端简历详情
import bossReceived from '@/pages/boss/received' // 园长端收到的简历
import bossAddSchool from '@/pages/boss/addSchool' // 园长端收到的简历

import chat from '@/pages/chat/index' // 消息

import login from '@/pages/login' // 登录


const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  // name: 路由名称
  // path：跳转url，
  // active：当前导航栏激活
  // component：文件
  // hide：是否显示在导航栏
  routes: [
    {
        name: '登录',
        path: '/login',
        active: true,
        component: login,
        port: 'teacher',
        hide: true
    },
    {
        name: '消息',
        path: '/chat',
        active: false,
        component: chat,
        hide: true
    },
    {
        name: '首页',
        path: '/',
        active: true,
        component: jobIndex,
        port: 'teacher'
    },
    {
        name: '职位',
        path: '/job/post',
        active: false,
        component: jobPost,
        port: 'teacher'
    },
    {
        name: '简历',
        path: '/job/resume',
        active: false,
        component: jobResume,
        hide: true
    },
    {
        name: '账号设置',
        path: '/job/accountNumber',
        active: false,
        component: jobAccountNumber,
        hide: true
    },
    {
        name: '职位详情',
        path: '/job/postDetail',
        active: false,
        component: jobPostDetail,
        hide: true
    },
    {
        name: '园所详情',
        path: '/job/schoolDetail',
        active: false,
        component: jobSchoolDetail,
        hide: true
    },
    {
        name: '我要招聘',
        path: '/boss/resume',
        active: true,
        component: bossResume,
        port: 'boss'
    },
    {
        name: '职位管理',
        path: '/boss/post',
        active: false,
        component: bossIndex,
        port: 'boss'
    },
    {
        name: '职位编辑',
        path: '/boss/postDetail',
        active: false,
        component: bossPostDetail,
        port: 'boss',
        hide: true
    },
    {
        name: '我的园所',
        path: '/boss/school',
        active: false,
        component: bossSchool,
        port: 'boss',
        hide: true
    },
    {
        name: '简历详情',
        path: '/boss/resumeDetail',
        active: false,
        component: bossResumeDetail,
        port: 'boss',
        hide: true
    },
    {
        name: '收到的简历',
        path: '/boss/received',
        active: false,
        component: bossReceived,
        port: 'boss'
    },
    {
        name: '新增园所',
        path: '/boss/addSchool',
        active: false,
        component: bossAddSchool,
        port: 'boss',
        hide: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js